const isSite = programName => (
  (programName === 'Kids Cafe' || programName === 'Partner Services')
);

export default isSite;
